import { createContext } from 'react';
import type { Control, FieldErrorsImpl } from 'react-hook-form';
import { IncompleteBusinessFormData } from './types';

interface FormContextProps {
  control: Control<IncompleteBusinessFormData>;
  errors: Partial<
    FieldErrorsImpl<{
      [x: string]: any;
    }>
  >;
}

export const FormContext = createContext<FormContextProps>({
  control: {} as Control<IncompleteBusinessFormData>,
  errors: {}
});
